<app-side-menu>
  <div class="accounts-payable-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="supplierFilter" class="form-label">Filtrar por Fornecedor:</label>
          <select 
            id="supplierFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedSupplierId"
            (change)="onSupplierFilterChange(filters.selectedSupplierId)">
            <option value="">Todos os fornecedores</option>
            <option *ngFor="let supplier of suppliers" [value]="supplier.id">
              {{ supplier.companyName }}
            </option>
            <option *ngIf="suppliers.length === 0" disabled>Nenhum fornecedor encontrado</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedStatus"
            (change)="onStatusFilterChange(filters.selectedStatus)">
            <option value="">Todos os status</option>
            <option *ngFor="let status of statusOptions" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="categoryFilter" class="form-label">Filtrar por Categoria:</label>
          <select 
            id="categoryFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedCategory"
            (change)="onCategoryFilterChange(filters.selectedCategory)">
            <option value="">Todas as categorias</option>
            <option *ngFor="let category of categoryOptions" [value]="category">
              {{ category }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="costCenterFilter" class="form-label">Filtrar por Centro de Custo:</label>
          <select 
            id="costCenterFilter" 
            class="form-select" 
            [(ngModel)]="filters.selectedCostCenterId"
            (change)="onCostCenterFilterChange(filters.selectedCostCenterId)">
            <option value="">Todos os centros</option>
            <option *ngFor="let cc of costCenters" [value]="cc.id">
              {{ cc.code }} — {{ cc.name }}
            </option>
            <option *ngIf="costCenters.length === 0" disabled>Nenhum centro de custo encontrado</option>
          </select>
        </div>

        
      </div>
      <div class="filters-row">
        <div class="filter-group">
          <label class="form-label">Faixa de Vencimento:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="filters.dueStartDate" (change)="onDueRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="filters.dueEndDate" (change)="onDueRangeChange()"/>
          </div>
        </div>
        <div class="filter-group">
          <label class="form-label">Faixa de Pagamento:</label>
          <div class="d-flex gap-2">
            <input type="date" class="form-control" [(ngModel)]="filters.paymentStartDate" (change)="onPaymentRangeChange()"/>
            <span class="align-self-center">até</span>
            <input type="date" class="form-control" [(ngModel)]="filters.paymentEndDate" (change)="onPaymentRangeChange()"/>
          </div>
        </div>
        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Contas a Pagar -->
    <div *ngIf="!error">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="accountsPayable"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [disablePagination]="false"
        [totalItemsFromBackend]="totalItems"
        [currentPageFromBackend]="currentPage"
        [itemsPerPage]="pageSize"
        [totalPagesFromBackend]="totalPages"
        [hasNextPageFromBackend]="hasNextPage"
        [hasPreviousPageFromBackend]="hasPreviousPage"
        [enableSorting]="true"
        [clientSideSort]="true"
        [searchTerm]="filters.searchTerm"
        (actionClick)="onActionClick($event)"
        (searchChange)="onSearchChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        [searchPlaceholder]="'Buscar por documento, NF, PO ou descrição'">
        <app-button
          *appHasPermission="'AccountsPayable.Create'"
          table-header-action
          text="Nova Conta a Pagar"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-ap-btn"
          (buttonClick)="newAccountsPayable()">
        </app-button>
        <app-button
          *appHasPermission="'AccountsPayable.Create'"
          table-header-action
          text="Devolução de caução"
          [color]="'var(--success-color, #198754)'"
          [height]="'42px'"
          className="deposit-refund-list-btn"
          (buttonClick)="openDepositRefundModal()">
        </app-button>
      </app-table>
    </div>

    

    

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>

  <app-modal
    [isOpen]="showDepositRefundModal"
    title="Devolução de caução — selecionar contrato"
    size="lg"
    [closable]="true"
    (close)="closeDepositRefundModal()">
    <div class="deposit-refund-modal">
      <p class="text-muted mb-3">
        Escolha o tipo de contrato, busque e selecione para abrir a devolução de caução (conta a pagar pendente).
      </p>

      <div class="btn-group mb-3 w-100" role="group">
        <button
          type="button"
          class="btn"
          [class.btn-primary]="depositRefundMode === 'b2c'"
          [class.btn-outline-primary]="depositRefundMode !== 'b2c'"
          (click)="setDepositRefundMode('b2c')">
          B2C — Locação
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-primary]="depositRefundMode === 'b2b'"
          [class.btn-outline-primary]="depositRefundMode !== 'b2b'"
          (click)="setDepositRefundMode('b2b')">
          B2B — Empresas
        </button>
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="depositRefundSearch"
          (ngModelChange)="onDepositRefundSearchChange()"
          placeholder="Buscar por número, motorista, empresa..." />
      </div>

      <div *ngIf="depositRefundLoading" class="text-center py-4">
        <span class="spinner-border text-primary"></span>
      </div>

      <div *ngIf="!depositRefundLoading && depositRefundResults.length === 0" class="alert alert-light mb-0">
        Nenhum contrato encontrado. Digite na busca ou troque o tipo B2C/B2B.
      </div>

      <div class="list-group deposit-refund-contract-list" *ngIf="!depositRefundLoading && depositRefundResults.length > 0">
        <button
          type="button"
          class="list-group-item list-group-item-action"
          *ngFor="let row of depositRefundResults"
          (click)="goToDepositRefund(row.id)">
          <div class="d-flex justify-content-between align-items-start gap-2">
            <div>
              <div class="fw-semibold">{{ row.title }}</div>
              <small class="text-muted">{{ row.subtitle }}</small>
            </div>
            <div class="text-end" *ngIf="row.depositAmount != null && row.depositAmount > 0">
              <small class="text-muted d-block">Caução</small>
              <span class="fw-semibold text-primary">{{ row.depositAmount | currency:'BRL':'symbol':'1.2-2' }}</span>
            </div>
          </div>
          <small class="text-warning d-block mt-1" *ngIf="row.hint">{{ row.hint }}</small>
        </button>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeDepositRefundModal()">Fechar</button>
    </div>
  </app-modal>

  <app-modal
    [isOpen]="showCreateModeModal"
    title="Nova conta a pagar — tipo de cadastro"
    size="lg"
    [closable]="true"
    (close)="closeCreateModeModal()">
    <p class="text-muted mb-3">
      Escolha como deseja cadastrar. Cada opção abre o mesmo fluxo em etapas, já adaptado ao seu setor financeiro.
    </p>
    <div class="row g-3 ap-create-mode-cards">
      <div class="col-md-4">
        <button type="button" class="ap-create-mode-card" (click)="startNewAccountsPayable('normal')">
          <i class="fas fa-receipt fa-2x text-primary mb-2"></i>
          <strong>Pagamento normal</strong>
          <small class="text-muted d-block mt-1">Um título único, sem parcelas em lote.</small>
        </button>
      </div>
      <div class="col-md-4">
        <button type="button" class="ap-create-mode-card" (click)="startNewAccountsPayable('parcelado')">
          <i class="fas fa-calendar-alt fa-2x text-primary mb-2"></i>
          <strong>Pagamento parcelado</strong>
          <small class="text-muted d-block mt-1">Várias parcelas de uma mesma conta (um centro de custo).</small>
        </button>
      </div>
      <div class="col-md-4">
        <button type="button" class="ap-create-mode-card" (click)="startNewAccountsPayable('rateio')">
          <i class="fas fa-chart-pie fa-2x text-primary mb-2"></i>
          <strong>Divisão em centro de custo</strong>
          <small class="text-muted d-block mt-1">Parcelas mensais divididas por % entre vários centros de custo.</small>
        </button>
      </div>
    </div>
    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeCreateModeModal()">Cancelar</button>
    </div>
  </app-modal>
</app-side-menu>
